class SliderCardsYears extends HTMLElement
{
    swiper;

    constructor()
    {
        super();
    }

    connectedCallback()
    {
        const container = this.querySelector('.swiper')
        const pagination = this.querySelector('.swiper-pagination')

        this.swiper = new Swiper(container, {
            slidesPerView: 'auto',
            pagination: {
                el: pagination,
                clickable: true,
                renderBullet: function(_index, className) {
                    return `<span class="${ className }"></span>`
                }
            }
        })
    }
}

customElements.define('slider-cards-years', SliderCardsYears)